import Feature from "ol/Feature";
import Map from "ol/Map";
import PropTypes from "prop-types";
import { Component } from "react";
import { MdClose } from "react-icons/md";
import { connect } from "react-redux";

import { TRACK_EVENT_CATEGORY_DEPARTURES } from "../constants";
import markerImg from "../img/marker.png";
import {
  setHighlightStation,
  setStation,
  unsubscribeDepartures,
} from "../model/actions";
import AppPropTypes from "../model/propTypes";

import Button from "./controls/Button";
import StationIcons from "./StationIcons";

import "./StationTitle.scss";

const propTypes = {
  debug: AppPropTypes.debugMode,
  departuresListCloseButton: PropTypes.bool,
  dispatchSetHighlightStation: PropTypes.func.isRequired,
  dispatchSetStation: PropTypes.func.isRequired,

  dispatchUnsubscribeDepartures: PropTypes.func.isRequired,
  map: PropTypes.instanceOf(Map),
  station: PropTypes.instanceOf(Feature),
};

const defaultProps = {
  debug: false,
  departuresListCloseButton: true,
  map: null,
  station: null,
};

class StationTitle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      debugTime: new Date(),
    };
  }

  /**
   * Remote all departures and disconnect.
   */
  clearDepartures() {
    const { dispatchSetStation, dispatchUnsubscribeDepartures } = this.props;
    dispatchUnsubscribeDepartures();
    dispatchSetStation(null);
  }

  componentDidUpdate() {
    const { debug } = this.props;
    window.clearInterval(this.debugTimer);
    if (debug) {
      this.debugTimer = window.setInterval(() => {
        this.setState({ debugTime: new Date() });
      }, 1000);
    }
  }

  render() {
    const { debug, departuresListCloseButton, station } = this.props;
    const { debugTime } = this.state;
    let debugInfo = null;

    if (!station) {
      return null;
    }

    if (debug) {
      debugInfo = (
        <span style={{ fontSize: "11px" }}>
          &nbsp;
          {debugTime.toString()}
        </span>
      );
    }
    const properties = station.getProperties() || {};

    return (
      <div
        id="station-name"
        onClick={() => this.zoomToStation()}
        onKeyPress={(e) => e.which === 13 && this.zoomToStation()}
        role="button"
        tabIndex={0}
      >
        <div className="marker">
          <img alt="Marker" src={markerImg} />
        </div>

        <div className="name">
          <div>{station.get("name")}</div>
          <StationIcons
            {...properties}
            trackEventCategory={TRACK_EVENT_CATEGORY_DEPARTURES}
          />
          {/* <StationTransfers
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...properties}
          /> */}
          {debugInfo}
        </div>
        {departuresListCloseButton !== false && (
          <Button
            className="close-button"
            onClick={() => this.clearDepartures()}
            tabIndex={-2}
          >
            <MdClose focusable={false} />
          </Button>
        )}
      </div>
    );
  }

  zoomToStation() {
    const { dispatchSetHighlightStation, map, station } = this.props;
    if (map) {
      map.updateSize();
      window.scroll({ behavior: "smooth", top: 0 });
    }
    if (station) {
      dispatchSetHighlightStation(station);

      window.setTimeout(() => {
        dispatchSetHighlightStation(null);
      }, 500);
    }
  }
}

StationTitle.propTypes = propTypes;
StationTitle.defaultProps = defaultProps;

const mapStateToProps = (state) => ({
  debug: state.debug,
  departuresListCloseButton: state.config?.departuresListCloseButton,
  map: state.map,
  station: state.station,
});

const mapDispatchToProps = {
  dispatchSetHighlightStation: setHighlightStation,
  dispatchSetStation: setStation,
  dispatchUnsubscribeDepartures: unsubscribeDepartures,
};

export default connect(mapStateToProps, mapDispatchToProps)(StationTitle);
